export function YourCvOnlyValue({
  yourCvOnlyLabel,
}: {
  yourCvOnlyLabel: string;
}) {
  return (
    <p className="flex items-end gap-1 text-2xl font-medium leading-8 text-primary">
      1
      <span className="mb-1 text-sm font-normal text-gray-800">
        {yourCvOnlyLabel}
      </span>
    </p>
  );
}
